export default __webpack_public_path__ + "static/media/hostinger-horizontal.33ff9709.svg";